/**
 * @file
 * Mitglieder switch filter - toggle that auto-submits the exposed form.
 * Used for field_gestorben_value (alle Mitglieder seit 1909 / aktuelle Mitglieder).
 */
(() => {
  (function (Drupal, once, $) {
    'use strict';

    Drupal.behaviors.mitgliederSwitchFilter = {
      attach: function (context) {
        once('mitgliederSwitchFilter', '[data-filter-switch]', context).forEach(function (wrap) {
          const checkbox = wrap.querySelector('.form-check-input');
          const hidden = wrap.querySelector('input[type="hidden"]');
          const form = wrap.closest('form');

          if (!checkbox || !hidden || !form) {
            console.warn('Mitglieder switch filter: missing checkbox, hidden input or form');
            return;
          }

          const leftLabelEl = wrap.querySelector('.switch-label-left');
          const rightLabelEl = wrap.querySelector('.switch-label-right');
          const onValue = wrap.getAttribute('data-on') || '';
          const offValue = wrap.getAttribute('data-off') || 'All';

          // Get current value from hidden input (already set correctly by server after AJAX)
          const currentValue = hidden.value || offValue;

          // Set checkbox state based on hidden input value
          checkbox.checked = (currentValue === onValue);

          // Update label styles based on current state
          function updateLabels() {
            if (checkbox.checked) {
              if (rightLabelEl) rightLabelEl.classList.add('fw-bold');
              if (rightLabelEl) rightLabelEl.classList.remove('fw-light');
              if (leftLabelEl) leftLabelEl.classList.remove('fw-bold');
              if (leftLabelEl) leftLabelEl.classList.add('fw-light');
            } else {
              if (leftLabelEl) leftLabelEl.classList.add('fw-bold');
              if (leftLabelEl) leftLabelEl.classList.remove('fw-light');
              if (rightLabelEl) rightLabelEl.classList.remove('fw-bold');
              if (rightLabelEl) rightLabelEl.classList.add('fw-light');
            }
          }

          // Initial label state
          updateLabels();

          // Handle switch change
          checkbox.addEventListener('change', function () {
            // Update hidden value
            hidden.value = checkbox.checked ? onValue : offValue;

            // Update label styles
            updateLabels();

            // Trigger form submission using jQuery for proper Drupal AJAX handling
            const $form = $(form);
            const $submitBtn = $form.find('[data-drupal-selector="edit-submit-mitglieder-view"], input[type="submit"], button[type="submit"]').first();

            if ($submitBtn.length) {
              $submitBtn.trigger('click');
            } else {
              form.submit();
            }
          });

          checkbox.addEventListener('keydown', function (event) {
            if (event.key !== 'Enter') return;
            event.preventDefault();
            checkbox.checked = !checkbox.checked;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
          });

          // Allow clicking on labels to toggle switch
          if (leftLabelEl) {
            leftLabelEl.style.cursor = 'pointer';
            leftLabelEl.addEventListener('click', function () {
              if (checkbox.checked) {
                checkbox.checked = false;
                checkbox.dispatchEvent(new Event('change'));
              }
            });
          }

          if (rightLabelEl) {
            rightLabelEl.style.cursor = 'pointer';
            rightLabelEl.addEventListener('click', function () {
              if (!checkbox.checked) {
                checkbox.checked = true;
                checkbox.dispatchEvent(new Event('change'));
              }
            });
          }
        });
      }
    };
  })(Drupal, once, jQuery);
})();
